// MSAL configuration for React frontend
export const msalConfig = {
  auth: {
    clientId: "16cc6859-1803-4803-af0b-b4ad8950c00a", // TODO: Replace with your Azure AD App client ID
    authority: "https://login.microsoftonline.com/872785ca-3bd8-48bc-84a4-e02ca1dcc42b", // TODO: Replace with your Azure AD tenant ID
    redirectUri: window.location.origin,
  },
};

export const loginRequest = {
  scopes: [
    "api://16cc6859-1803-4803-af0b-b4ad8950c00a/access_as_user",
    "User.Read",
    "profile"
  ]
};
